import React from "react";

// OPTION 2 — "Freight Shield Crest"
// A shield/crest conveying trust and strength. Teal shield with a globe and an
// upward growth arrow inside (capital / recovery), split navy base. Corporate powerhouse.
export default function LogoOption2({ variant = "dark", size = 52 }) {
  const navy = "#1b2545";
  const teal = "#2fb89c";
  const textMain = variant === "light" ? "#ffffff" : navy;

  return (
    <div className="flex items-center gap-3 select-none">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        {/* shield */}
        <path d="M32 3 L57 12 V33 C57 48 45 57 32 61 C19 57 7 48 7 33 V12 Z" fill={navy} />
        <path d="M32 3 L57 12 V33 C57 48 45 57 32 61 C19 57 7 48 7 33 V12 Z" stroke={teal} strokeWidth="2" />
        {/* globe latitude/longitude */}
        <circle cx="32" cy="28" r="12" stroke={teal} strokeWidth="1.8" fill="none" opacity="0.55" />
        <ellipse cx="32" cy="28" rx="4.5" ry="12" stroke={teal} strokeWidth="1.4" fill="none" opacity="0.55" />
        <line x1="20" y1="28" x2="44" y2="28" stroke={teal} strokeWidth="1.4" opacity="0.55" />
        {/* upward growth arrow */}
        <path d="M22 38 L30 30 L36 35 L46 23" stroke={teal} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M40 23 H46 V29" stroke={teal} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      <div className="leading-none">
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 20, color: textMain, letterSpacing: "1px", lineHeight: 1 }}>
          WWD
        </div>
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 700, fontSize: 11, color: teal, letterSpacing: "1.5px", lineHeight: 1.3, marginTop: 4 }}>
          WORLD WIDE
        </div>
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 700, fontSize: 11, color: variant === "light" ? "#cdd6e4" : "#495066", letterSpacing: "1.5px", lineHeight: 1.3 }}>
          WHOLESALE DEALS LLC
        </div>
      </div>
    </div>
  );
}
